<template>
  <div class="wrap">
    <div class="apply_tips">
      <div class="money">
        <div class="money_title">{{ $t('balance') }}</div>
        <div class="money_num" v-if="userInfo.loan && (userInfo.loan.status == 0)">{{ $money(userInfo.loan.money) }}
        </div>
        <div class="money_num" v-else>{{ $money(userInfo.money) }}</div>
        <!-- <div v-else>{{ $money(0) }}</div> -->
        <!-- <div class="money_rate">1USD ≈ {{ (1 / ArsRate.rate).toFixed(2) }} {{ verConfig.moneyType }}</div> -->
      </div>
      <img src="@/assets/new/login/logo.png" alt="">
    </div>
    <div class="apply_box">
      <!-- <div class="btn" @click="infoClick">{{ userInfo.auth_level == 2 ? $t('goods.wallet') : $t('goods.completeInfo') }}
      </div> -->
      <div class="read">
        <van-radio-group v-model="readRadio" checked-color="var(--newColor)">
          <van-radio name="1">{{ $t('goods.readAgree') }}</van-radio>
        </van-radio-group>
        <div class="policy" @click="overlayShow = true">{{ $t('goods.policyDepartment') }}</div>
      </div>
    </div>
    <div class="cont_list">
      <div class="list" v-for="item, index in list" :key="index" @click="hanldeTo(item)">
        <div class="list_img">
          <img :src="item.img" alt="">
        </div>
        <div class="text">{{ $t(item.text) }}</div>
      </div>
    </div>
    <div class="menu">
      <img src="@/assets/new/index/menu.png" alt="">
    </div>
    <!-- <div class="btns">
      <div class="btns_item" @click="hanldeTo({ path: '/partner' })">
        <img src="@/assets/new/index/cooperate.png" alt="">
        <span>{{ $t('合作') }}</span>
      </div>
      <div class="btns_item" @click="hanldeTo({ path: 'aboutUs' })">
        <img src="@/assets/new/index/about.png" alt="">
        <span>{{ $t('goods.aboutUs') }}</span>
      </div>
    </div> -->
    <div class="btn" @click="hanldeTo({ path: '/user' })">{{ $t('设置') }}</div>
    <van-overlay :show="overlayShow" :lock-scroll="false" @click="overlayShow = false" z-index="10"
      class="about_overlay">
      <div class="wrapper" @click.stop>
        <div v-html="agreement"></div>
      </div>
    </van-overlay>
    <van-overlay :show="aboutShow" :lock-scroll="false" @click="aboutShow = false" z-index="10" class="about_overlay">
      <div class="wrapper" @click.stop>
        <div v-html="about"></div>
      </div>
    </van-overlay>
    <van-popup v-model="popShow" position="bottom" class="pop">
      <div class="pop_sign">
        <div class="sign_title">{{ $t('请签名') }}</div>
        <div class="sign_cont">
          <vue-esign ref="esign" :width="400" :height="200" :isCrop="isCrop" :lineWidth="lineWidth"
            :lineColor="lineColor" />
        </div>
        <div class="sing_btn">
          <div class="_btn" @click="handleReset">{{ $t('重签') }}</div>
          <div class="_btn" @click="handleGenerate">{{ $t('user.Button.Two') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, RadioGroup, Radio, Overlay, Popup } from "vant";
import Cookies from "js-cookie";
import verConfig from "@/utils/verConfig";
import { mapGetters } from "vuex";
import vueEsign from 'vue-esign'
import { USERS_EDIT, THIRD_TARE } from "@/api"

export default {
  components: {
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    vueEsign
  },
  data() {
    return {
      popShow: false,
      aboutShow: false,
      readRadio: '1',
      list: [{
        img: require('@/assets/new/index/payment.png'),
        text: 'goods.wallet',
        path: 'wallet'
      },
      //  {
      //   img: require('@/assets/new/index/recharge.png'),
      //   text: 'topUp',
      //   path: '/new-recharge'
      // }, {
      //   img: require('@/assets/new/index/withdrawal.png'),
      //   text: '提现',
      //   path: '/new-withdraw'
      // },
      {
        img: require('@/assets/new/index/transaction.png'),
        text: '交易',
        path: '/withdraw-list'
      },
      {
        img: require('@/assets/new/index/contract.png'),
        text: 'goods.contract',
        path: '/contract'
      },
      {
        img: require('@/assets/new/index/repayment.png'),
        text: 'goods.repayment',
        path: '/repayDetail'
      }, {
        img: require('@/assets/new/index/cooperate.png'),
        text: 'goods.cooperation',
        path: '/partner'
      }, {
        img: require('@/assets/new/index/about.png'),
        text: 'goods.aboutUs',
        path: 'aboutUs'
      },
        // {
        //   img: require('@/assets/new/history.png'),
        //   text: 'goods.history',
        //   path: '/transactionHistory'
        // }, 
        //  {
        //   img: require('@/assets/new/contract.png'),
        //   text: 'goods.contract',
        //   path: '/contract'
        // }, 

      ],
      overlayShow: false,
      lineWidth: 2,
      lineColor: '#000000',
      resultImg: '',
      isCrop: false,
      contHtml: 'agreement',
      ArsRate: {}
    }
  },
  computed: {
    ...mapGetters(["userInfo", "about", 'agreement']),
  },
  methods: {
    handleReset() {
      this.$refs.esign.reset()
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.submitSign(res)
        this.popShow = false;
      }).catch(err => {
        Toast(this.$t('请签名'))
      })
    },
    infoClick() {
      if (this.userInfo.auth_level == 1) {
        return this.hanldeTo({ path: '/question' })
      }
      if (this.userInfo.auth_level == 2) {
        return this.hanldeTo({ path: '/wallet' })
      }
      this.hanldeTo({ path: '/baseInfo' })
    },
    async submitSign(sign_pic) {
      Toast.loading();
      try {
        const res = await USERS_EDIT({ sign_pic });
        Toast.clear();
        this.handleReset();
        this.$store.dispatch('getUserInfo');
        this.infoClick();
      } catch (error) {
        Toast.clear();
        Toast(error.msg);
      }
    },
    hanldeTo(item) {
      if (!item.path) return;
      if (item.path == 'aboutUs') { return this.aboutShow = true; };
      if (item.path == 'wallet') {
        if (!this.userInfo.sign_pic) return this.popShow = true;
        this.infoClick();
        return
      }
      if (item.path == '/wallet') {
        if (this.userInfo.auth_level == 1) {
          return this.$router.push('/question');
        }
        if (this.userInfo.auth_level == 2) {
          return this.$router.push('/wallet');
        }
        return this.$router.push('/baseInfo')
      }
      this.$router.push(item.path)
    },
    async getRate() {
      try {
        const res = await THIRD_TARE();
        this.ArsRate = res.data.find((item) => item.title == 'ARS');
      } catch (error) { }
    }
  },
  created() {
    this.$store.dispatch('getUserInfo');
    this.getRate()
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
@Color: rgb(222, 140, 23);
@bg: var(--bg);
@sizeColor: var(--sizeColor);
@newBg: #ff004f;

.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.wrap {
  min-height: 100vh;
  background: var(--userBg) no-repeat;
  background-size: cover;

  .apply_tips {
    // background: var(--btnColor);
    background: url('../../assets/new/index/bg.png') no-repeat;
    background-size: 100% 100%;
    color: var(--white);
    border-radius: calc(20rem / 16);
    margin: calc(20rem / 16) calc(20rem / 16) 0;
    // border: 1px solid var(--white);
    padding-left: calc(20rem / 16);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .money {
      font-size: calc(18rem / 16);
      font-weight: bold;
      // color: var(--btnsizeColor);

      .money_title {
        margin-bottom: 5px;
      }
      .money_rate{
        position: absolute;
        bottom: calc(6rem / 16);
        width: 100%;
        font-size: calc(14rem / 16);
      }
    }

    img {
      height: 130px;
      display: block;
    }
  }

  .apply_box {
    .btn {
      height: calc(45rem / 16);
      border-radius: calc(8rem / 16);
      background: #f96;
      color: var(--white);
      font-size: calc(16rem / 16);
      text-align: center;
      line-height: calc(45rem / 16);
    }

    .read {
      font-size: calc(12rem / 16);
      padding: 0 calc(20rem / 16) calc(10rem / 16);
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .van-radio__icon {
        display: flex;
        align-items: center;
      }

      /deep/ .van-icon {
        width: calc(16rem / 16);
        height: calc(16rem / 16);
        font-size: calc(12rem / 16);
        line-height: calc(16rem / 16)
      }

      /deep/ .van-radio__label {
        color: #1b283d;
        line-height: calc(20rem / 16);
      }

      .policy {
        margin-left: calc(5rem / 16);
        color: #1446FA;
        line-height: calc(20rem / 16);
      }
    }
  }

  .cont_list {
    display: flex;
    flex-wrap: wrap;
    gap: calc(12rem / 16) calc(16rem / 16);
    margin: 0 calc(20rem / 16) calc(16rem / 16);
    background: #fff;
    border-radius: 16px;
    padding: 16px 0;

    .list {
      width: calc((100% - 32rem / 16) / 3);
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      
      .list_img {
        width: fit-content;
        padding: calc(16rem / 16) calc(20rem / 16);
        display: flex;
        align-items: center;
        justify-content: center;
        // background: var(--btnColor);
        border-radius: calc(8rem / 16);
        // background-color: #7D6983;

        img {
          // width: calc(35rem / 16);
          height: calc(40rem / 16);
          display: block;
          // margin-right: calc(5rem / 16);
        }
      }

      .text {
        margin-top: calc(5rem / 16);
        color: #1b283d;
        font-size: calc(14rem / 16);
        text-align: center;
      }
    }
  }

  .menu {
    padding: 0 calc(20rem / 16);
    overflow: hidden;

    img {
      border-radius: calc(5rem / 16);
      width: 100%;
      display: block;
    }
  }

  .btn {
    margin: calc(20rem / 16) calc(20rem / 16) calc(20rem / 16);
    background: var(--btnColor);
    color: var(--btnsizeColor);
    height: calc(48rem / 16);
    line-height: calc(48rem / 16);
    text-align: center;
    border-radius: calc(10rem / 16);
    font-weight: bold;
  }

  .btns {
    padding: calc(20rem / 16);
    display: flex;
    gap: calc(20rem / 16);

    .btns_item {
      flex: 1;
      min-height: calc(135rem / 16);
      background: var(--btnColor);
      border-radius: calc(10rem / 16);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        height: calc(50rem / 16);
        display: block;
      }

      span {
        color: var(--btnsizeColor);
        font-size: calc(16rem / 16);
        margin-top: calc(5rem / 16);
      }
    }
  }

  .about_overlay {
    display: flex;
    align-items: center;
    overflow: hidden;

    .wrapper {
      padding: calc(10rem / 16);
      background-color: var(--white);
      margin: auto;
      max-height: calc(100% - 150rem / 16);
      width: 80%;
      overflow-y: scroll;

      /deep/ img {
        max-width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .pop {
    border-radius: calc(12rem / 16) calc(12rem / 16) 0 0;
    background-color: var(--white);

    .pop_sign {
      .sign_title {
        padding: calc(16rem / 16) 0;
        text-align: center;
        color: var(--theme);
        font-weight: 700;
      }

      .sign_cont {
        margin: 0 calc(12rem / 16) calc(12rem / 16);
        border: 1px dashed #bbb5b5;
        border-radius: calc(12rem / 16);
        overflow: hidden;
      }

      .sing_btn {
        display: flex;
        padding: 0 calc(12rem / 16) calc(12rem / 16);
        align-items: center;
        justify-content: space-between;

        ._btn {
          display: flex;
          align-items: center;
          font-size: calc(14rem / 16);
          color: var(--white);
          background: var(--nav-background);
          padding: calc(6rem / 16) calc(10rem / 16);
          border-radius: calc(5rem / 16);
        }
      }
    }
  }
}
</style>
